(function () {
  // Deadline comes from the section setting via data-deadline; the literal is a fallback.
  var roots = document.querySelectorAll('[data-countdown-root]');
  if (!roots.length) return;

  var DEADLINE = new Date(roots[0].getAttribute('data-deadline') || '2026-06-14T23:59:00-05:00').getTime();
  if (isNaN(DEADLINE)) DEADLINE = new Date('2026-06-14T23:59:00-05:00').getTime();

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var diff = DEADLINE - Date.now();
    var ended = diff <= 0;
    if (ended) diff = 0;
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor(diff / 3600000) % 24;
    var mins = Math.floor(diff / 60000) % 60;
    var secs = Math.floor(diff / 1000) % 60;
    roots.forEach(function (root) {
      root.querySelector('[data-cd="days"]').textContent = pad(days);
      root.querySelector('[data-cd="hours"]').textContent = pad(hours);
      root.querySelector('[data-cd="mins"]').textContent = pad(mins);
      root.querySelector('[data-cd="secs"]').textContent = pad(secs);
    });
    if (!ended) setTimeout(tick, 1000);
  }

  tick();
})();
